import { render, staticRenderFns } from "./AllReportsTable.vue?vue&type=template&id=5cdc3e76&scoped=true&"
import script from "./AllReportsTable.vue?vue&type=script&lang=js&"
export * from "./AllReportsTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5cdc3e76",
  null
  
)

export default component.exports